<template>
  <div class="ad-series-wrap">
    <div class="card-header">广告组</div>
    <el-form :model="formData" :rules="rules" ref="ruleForm">
      <li class="form-item">
        <span class="form-label require">广告组名称：</span>
        <div class="form-value">
          <select-input ref="selectInputRef" placeholder="(必填)广告系列名称" :dataList="showAdList" v-model="formData.adGroupNameRule"></select-input>
        </div>
      </li>
    </el-form>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import { getTtV2ProjectList } from "@/api/promotion.js";
import nameTransforUtil from "./config/nameTransforUtil.js";
import SelectInput from "./components/selectInput.vue";
export default {
  components: {
    SelectInput,
  },
  data() {
    return {
      selectItem: [],
      projectNameList: [
        "创意组名称",
        "应用名称",
        "应用系统",
        "地区",
        "语言",
        "创建时间",
        "优化目标",
        "出价",
        "开始日期",
        "时分秒",
        "首个图片名称",
        "首个视频名称",
      ],
      showMore: true,
      formData: {
        adGroupNameRule: "",
      },
      rules: {
        adGroupNameRule: [
          {
            required: true,
            message: "请输入广告组名称",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    handleSelectItem(item, itemIndex) {
      let index = this.selectItem.findIndex((item) => item === itemIndex);
      if (index === -1) {
        this.selectItem.push(itemIndex);
        this.formData.adGroupNameRule += "{" + item + "}";
      } else {
        this.selectItem.splice(index, 1);
        this.formData.adGroupNameRule = this.formData.adGroupNameRule.replace("{" + item + "}", "");
      }
    },
    saveInStore() {
      this.$store.commit("set_adGroup_nameRule_google", nameTransforUtil.showDataToApi(this.formData.adGroupNameRule));
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.selectInputRef.checkData(),
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              this.saveInStore();
              resolve();
            } else {
              reject();
            }
          });
      });
    },
  },
  computed: {
    showAdList() {
      if (!this.showMore) {
        return this.projectNameList.slice(0, 6);
      }
      return this.projectNameList;
    },
    ...mapState({
      adGroupNameRule: (state) => state.PromotionGoogle.adGroupNameRule,
      alreadyCampaignId: (state) => state.PromotionGoogle.draftCampaign.campaignId,
    }),
  },
  watch: {
    adGroupNameRule(val) {
      this.formData.adGroupNameRule = nameTransforUtil.apiDatatoShow(val);
    },
  },
};
</script>

<style lang="less" scoped>
.ad-series-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
  }
  .form-item {
    display: flex;
    margin: 16px 0;
    /deep/.el-form-item__error {
      top: 11px;
      left: 330px;
    }
    /deep/ .el-form-item {
      margin-bottom: 6px;
    }
    .form-label {
      flex-shrink: 0;
      display: inline-block;
      width: 130px;
      text-align: right;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      padding-top: 6px;
      &.require::before {
        content: "*";
        display: inline-block;
        color: red;
        margin-right: 4px;
      }
    }
    .form-value {
      width: 100%;
      padding-top: 2px;
    }
  }
}
</style>
